import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getIssueCategories, viewIssueCategories, addIssueCategory, editIssueCategory, deleteIssueCategory, deleteImage, listHelpRequests, listMessages, getHelpMessages, sendMessage, getHelpRequestById, getInquiries, getInquiryDetails, markInquiryResolved, resolveIssueConversation } from '../api/help-desk';

// Rejection Reasons
// export const useRejectionReasons = () => {
//     return useQuery({
//         queryKey: ['rejection-reasons'],
//         queryFn: getRejectionReasons,
//     });
// };

// Issue Categories
export const useIssueCategories = () => {
    return useQuery({
        queryKey: ['issue-categories'],
        queryFn: getIssueCategories,
    });
};

export const useViewIssueCategories = (id) => {
    return useQuery({
        queryKey: ['view-issue-categories', id],
        queryFn: () => viewIssueCategories(id),
    });
};

export const useGetIssueCategories = () => {
    return useQuery({
        queryKey: ['get-issue-categories'],
        queryFn: getIssueCategories,
    });
};

export const useAddIssueCategory = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: addIssueCategory,
        onSuccess: () => {
            queryClient.invalidateQueries(['issue-categories']);
            queryClient.invalidateQueries(['view-issue-categories']);
            queryClient.invalidateQueries(['get-issue-categories']);
        },
    });
};

export const useEditIssueCategory = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ categoryId, categoryData }) => editIssueCategory(categoryId, categoryData),
        onSuccess: () => {
            queryClient.invalidateQueries(['issue-categories']);
            queryClient.invalidateQueries(['view-issue-categories']);
            queryClient.invalidateQueries(['get-issue-categories']);
        },
    });
};

export const useDeleteIssueCategory = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (categoryId) => deleteIssueCategory(categoryId),
        onSuccess: () => {
            queryClient.invalidateQueries(['issue-categories']);
            queryClient.invalidateQueries(['view-issue-categories']);
            queryClient.invalidateQueries(['get-issue-categories']);
        },
    });
};

// Image Deletion
export const useDeleteImage = () => {
    return useMutation({
        mutationFn: deleteImage,
    });
};

// Help Requests
export const useHelpRequests = () => {
    return useQuery({
        queryKey: ['help-requests'],
        queryFn: listHelpRequests,
    });
};

// Get issue by id
export const useGetIssueById = (id) => {
    return useQuery({
        queryKey: ['get-issue-by-id', id],
        queryFn: () => getHelpRequestById(id),
    });
};

// resolve issue conversation
export const useResolveIssue = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['resolve-issue'],
        mutationFn: (data) => resolveIssueConversation(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['get-issue-by-id']);
            queryClient.invalidateQueries(['help-requests']);
        }
    });
}

// Messages
export const useMessages = (id) => {
    return useQuery({
        queryKey: ['messages', id],
        queryFn: () => getHelpMessages(id),
    });
};

export const useSendMessage = (id) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (message) => sendMessage(id, message),
        onSuccess: () => {
            queryClient.invalidateQueries(['get-issue-by-id', id]);
        },
    });
};

// Inquiries
export const useGetInquiries = () => {
    return useQuery({
        queryKey: ['inquiries'],
        queryFn: getInquiries,
    });
};

export const useGetInquiryDetails = (id) => {
    return useQuery({
        queryKey: ['inquiry-details', id],
        queryFn: () => getInquiryDetails(id),
    });
}

export const useMarkInquiryResolved = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['mark-inquiry-resolved'],
        mutationFn: (id) => markInquiryResolved(id),
        onSuccess: () => {
            queryClient.invalidateQueries(['inquiry-details', 'inquiries']);
        }
    });
}